import { rootUrl } from '../../urls';

export const IDENTITY_CONFIG = {
    stsAuthority: 'https://www.cembenchmarking.com/identity2/core/', //(string): The URL of the OIDC provider.
    clientId: 'CEM.TemplateTool', //(string): Your client application's identifier as registered with the OIDC provider.
    clientSecret: "templateWillRuleTheWorld",
    clientRoot: rootUrl(),
    clientScope: 'openid profile email roles TemplateUploadToolApi'
};